export default __webpack_public_path__ + "static/security-by-design-52fbb53ce092d0a5be98121a0561645c.png";